module.exports = __webpack_public_path__ + "static/img/provider_logo.cc50c33b.png";